<script>
export default {
  data () {
    return {
    }
  },
  computed: {
    todo () {
      return this.$store.getters.todo
    }
  },
  methods: {
    getTodo (id) {
      this.$store.dispatch('getTodo', id)
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.getTodo(to.params.id)
    })
  },
  mounted () {
  },
  route: {
  }
}
</script>



// WEBPACK FOOTER //
// Todo.vue?54714da8